import {useGobernanzaEvaluation} from "saneamiento/gobernanza/hooks/GobernanzaEvaluationHook";
import {ResultsSummaryList} from "base/component/presentational";
import {SisbagalSectionCard} from "sisbagal/auth";

const GobernanzaSummaryConfianzaSection = ({gobernanza}) => {
    const {
        getDimensionEvaluationLabel,
        getDimensionEvaluationColor,
        getPrincipiosEvaluationColor,
    } = useGobernanzaEvaluation();

    const basePath = `/concellos/${gobernanza.concello}/gobernanza`;

    const listItems = [
        {
            label: "Integridade e transparencia:",
            to: `${basePath}/confianza`,
            total: gobernanza.total_integridade,
            evaluationColor: getPrincipiosEvaluationColor(
                gobernanza.total_integridade,
                "medium"
            ),
        },
        {
            label: "Compromiso das partes interesadas:",
            to: `${basePath}/confianza#2`,
            total: gobernanza.total_compromiso,
            evaluationColor: getPrincipiosEvaluationColor(
                gobernanza.total_compromiso,
                "low"
            ),
        },
        {
            label: "Equidade:",
            to: `${basePath}/confianza#3`,
            total: gobernanza.total_equidade,
            evaluationColor: getPrincipiosEvaluationColor(
                gobernanza.total_equidade,
                "low"
            ),
        },
        {
            label: "Monitoreo e avaliación:",
            to: `${basePath}/confianza#4`,
            total: gobernanza.total_monitoreo_avaliacion,
            evaluationColor: getPrincipiosEvaluationColor(
                gobernanza.total_monitoreo_avaliacion,
                "low"
            ),
        },
    ];

    return (
        <SisbagalSectionCard title="Confianza e participación">
            <ResultsSummaryList
                listItems={listItems}
                totalValue={gobernanza.total_confianza}
                totalLabel={getDimensionEvaluationLabel(gobernanza.total_confianza)}
                getChipColor={getDimensionEvaluationColor}
            />
        </SisbagalSectionCard>
    );
};

export default GobernanzaSummaryConfianzaSection;
